import { render, staticRenderFns } from "./EditTask.vue?vue&type=template&id=07a01869&scoped=true&"
import script from "./EditTask.vue?vue&type=script&lang=js&"
export * from "./EditTask.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/forms/theme-checkbox-radio.css?vue&type=style&index=0&id=07a01869&scoped=true&lang=css&"
import style1 from "@/assets/css/forms/switches.css?vue&type=style&index=1&id=07a01869&scoped=true&lang=css&"
import style2 from "./EditTask.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a01869",
  null
  
)

export default component.exports